export default __webpack_public_path__ + "static/media/connectedopennetwork.3add7549.png";